import type { GpsCoordinates } from "@services/GpsCoordinates";
import type { ILocation, ILocationDto } from "./ILocation";

export class Location implements ILocation
{
    name: string = '';
    description?: string;
    address?: string;
    addressLine1: string = '';
    addressLine2?: string;
    city: string = '';
    state: string = '';
    postcode: string = '';
    longitude?: number;
    latitude?: number;
    linkUrl?: string;
    email?: string;
    phone?: string;
    postcodes: string[] = [];
    heroImageUrl?: string;

    constructor( model: ILocationDto )
    {
        if( model == null ) return;
        this.name = model.name;
        this.address = model.address;
        this.description = model.description;
        this.addressLine1 = model.addressLine1;
        this.addressLine2 = model.addressLine2;
        this.city = model.city;
        this.state = model.state;
        this.postcode = model.postcode;
        this.longitude = model.longitude;
        this.latitude = model.latitude;
        this.linkUrl = model.linkUrl;
        this.email = model.email;
        this.phone = model.phone;
        this.postcodes = model.postcodes ?? [];
        this.heroImageUrl = model.heroImageUrl;
    }

    get hasFullAddress()
    {
        return ( !!this.addressLine1 && !!this.city && !!this.state && !!this.postcode );
    }

    get hasDescription()
    {
        return !!this.description;
    }

    get hasHeroImage()
    {
        return ( this.heroImageUrl ?? '' ).length > 0;
    }
    
    toString()
    {
        if( this.hasFullAddress )
        {
            return `${this.addressLine1}, ${this.city}, ${this.state} ${this.postcode}`;
        }

        else if( !!this.address )
        {
            return this.address!
        }
        return this.description ?? '';
    }

    /**
     * Gets the distance in km from the given lat/lng
     * @param fromLat 
     * @param fromLng 
     */
    getDistance( from?: GpsCoordinates )
    {
        if( ( this.latitude ?? 0 ) == 0 || ( this.longitude ?? 0 ) == 0 ) return undefined;
        if( from == null || from.latitude == undefined || from.longitude == undefined ) return undefined;
        const radians = ( degrees: number ) => degrees * Math.PI / 180;
        return Math.acos( ( Math.sin( radians( from.latitude ) ) * Math.sin( radians( this.latitude ?? 0 ) ) ) + ( Math.cos( radians( from.latitude ) ) * Math.cos( radians( this.latitude ?? 0 ) ) ) * ( Math.cos( radians( this.longitude ?? 0 ) - radians( from.longitude ) ) ) ) * 6371;
    }

    /**
     * Returns the geo coordinates as a lat/lng object
     * @returns 
     */
    toLatLng()
    {
        return { lat: String( this.latitude ), lng: String( this.longitude ) };
    }

    /**
     * True if the location has a lat/lng
     * @returns 
     */
    hasGeocode()
    {
        return this.latitude != null && this.longitude != null;
    }

}